import { useAuthStore } from '@/stores/auth.store';
import { TokenService } from './tokenService';
import { TokenScheduler } from './tokenScheduler';
import useHttp from '@/utils/httpClient';
import { AUTH_CONFIG } from './config';

export const useAuthentication = () => {
  const authStore = useAuthStore();
  const tokenService = new TokenService();
  const tokenScheduler = new TokenScheduler();

  const login = async () => {
    const token = await tokenService.login();
    tokenScheduler.scheduleAuthRefresh();
    return token;
  };

  /**
   * Re-authenticate using current apikey and channelKey from the store (e.g. after switching to agent channel key).
   * Does not read URL or re-initialize; uses existing store values. Schedules refresh.
   * @returns {Promise<string|null>} The new token or null on failure
   */
  const reAuthenticateWithCurrentParams = async () => {
    try {
      const http = useHttp();
      const res = await http.get(AUTH_CONFIG.ENDPOINTS.AUTHENTICATE);
      const token = res?.data ?? null;
      if (token) {
        authStore.setToken(token);
        tokenScheduler.scheduleAuthRefresh();
        return token;
      }
      return null;
    } catch {
      return null;
    }
  };

  return {
    login,
    reAuthenticateWithCurrentParams,
    bearer: authStore.bearer,
  };
};
